export default "__VITE_ASSET__NI0uJvSQ__"